(function (angular) {
  /**
   * Service: tenant
   */
  angular.module('acme.common.service.tenant', []).service('TenantService', TenantService);

  TenantService.$inject = [];

  function TenantService() {
    return {
      model: {},

      setModel: function (data) {
        this.model = data == null ? {} : data;
      },

      isRecurringPaymentEnabled: function () {
        return this.model.hasOwnProperty('recurringPaymentEnabled') && this.model.recurringPaymentEnabled;
      },
    };
  }
})(window.angular);
